import {
  FILE_TRANSFER_PROMO_STORAGE_KEY,
  FILE_TRANSFER_PROMO_STORAGE_VALUE,
} from "./fileTransferPromo.constants";

const getPromoStorage = (storage) => storage ?? window.localStorage;

/**
 * @param {{ storage?: Storage }} options
 * @returns {boolean}
 */
export const hasSeenFileTransferPromo = ({ storage } = {}) => {
  try {
    const promoStorage = getPromoStorage(storage);

    return (
      promoStorage.getItem(FILE_TRANSFER_PROMO_STORAGE_KEY) ===
      FILE_TRANSFER_PROMO_STORAGE_VALUE
    );
  } catch (error) {
    return false;
  }
};

/**
 * @param {{ storage?: Storage }} options
 * @returns {boolean}
 */
export const markFileTransferPromoSeen = ({ storage } = {}) => {
  try {
    const promoStorage = getPromoStorage(storage);

    promoStorage.setItem(
      FILE_TRANSFER_PROMO_STORAGE_KEY,
      FILE_TRANSFER_PROMO_STORAGE_VALUE
    );
    return true;
  } catch (error) {
    return false;
  }
};
